<template>
  <div class="car-number">
    <van-field v-model="formData.one" readonly @click="popupShow = true" />
    <van-field v-model="formData.two" ref="two" autocomplete="off" maxlength="1" @update:model-value="changeTwo" />
    <van-field
      v-model="formData.three"
      ref="three"
      autocomplete="off"
      maxlength="1"
      @update:model-value="changeThree"
    />
    <van-field v-model="formData.four" ref="four" autocomplete="off" maxlength="1" @update:model-value="changeFour" />
    <van-field v-model="formData.five" ref="five" autocomplete="off" maxlength="1" @update:model-value="changeFive" />
    <van-field v-model="formData.six" ref="six" autocomplete="off" maxlength="1" @update:model-value="changeSix" />
    <van-field v-model="formData.seven" ref="seven" autocomplete="off" maxlength="1" />
    <van-field v-model="formData.eight" autocomplete="off" maxlength="1" ref="eight" v-if="isNev" />
    <div v-else class="nengyuan">
      新能源
    </div>
  </div>
  <div class="error-msg" v-if="errorMes">
    {{ errorMes }}
  </div>
  <div class="checkbox-view">
    <van-checkbox shape="square" icon-size="18px" v-model="isNev">
      此车是新能源
    </van-checkbox>
  </div>

  <van-popup
    :overlay="false"
    v-model:show="popupShow"
    position="bottom"
    :style="{ height: '30%' }"
    class="bg-[#F2F6FA]"
  >
    <div class="grid grid-cols-8 gap-x-[10px] gap-y-[10px] p-[10px] pt-[18px]">
      <div
        v-for="item in city"
        :key="item"
        @click="changeCity(item)"
        class="bg-[#fff] h-[40px] rounded-[4px] text-center leading-[40px] text-[16px]"
        :class="formData.one == item && 'text-theme'"
      >
        {{ item }}
      </div>
    </div>
  </van-popup>
</template>
<script>
import { nextTick } from "vue";
import { reactive, ref, watch } from "vue";
export default {
  emits: ["change"],
  setup(props, { emit }) {
    const city = [
      "京",
      "津",
      "渝",
      "冀",
      "晋",
      "辽",
      "吉",
      "黑",
      "苏",
      "浙",
      "皖",
      "闽",
      "赣",
      "鲁",
      "豫",
      "鄂",
      "湘",
      "粤",
      "琼",
      "川",
      "贵",
      "云",
      "陕",
      "甘",
      "青",
      "桂",
      "蒙",
      "藏",
      "宁",
      "新"
    ];

    const isNev = ref(false);
    const two = ref();
    const three = ref();
    const four = ref();
    const five = ref();
    const six = ref();
    const seven = ref();
    const eight = ref();

    const formData = reactive({
      one: "京",
      two: "",
      three: "",
      four: "",
      five: "",
      six: "",
      seven: "",
      eight: ""
    });

    const popupShow = ref(false);

    const changeCity = item => {
      formData.one = item;
      popupShow.value = false;
      two.value.focus();
    };

    const changeTwo = () => {
      if (formData.two) three.value.focus();
    };
    const changeThree = () => {
      if (formData.three) four.value.focus();
    };
    const changeFour = () => {
      if (formData.four) five.value.focus();
    };
    const changeFive = () => {
      if (formData.five) six.value.focus();
    };
    const changeSix = () => {
      if (formData.six) seven.value.focus();
    };

    const errorMes = ref("");

    const handleErr = () => watchFromData();

    const watchFromData = () => {
      const pattern1 = /^[a-zA-Z]+$/;
      const result = pattern1.test(formData.two);

      const pattern2 = /^[a-zA-Z0-9]+$/;

      const twoVal = formData.two;
      const threeVal = formData.three;
      const fourVal = formData.four;
      const fiveVal = formData.five;
      const sixVal = formData.six;
      const sevenVal = formData.seven;
      const eightVal = formData.eight;

      if (twoVal && !result) {
        errorMes.value = "首位必须为字母";
      } else if (!threeVal || !fourVal || !fiveVal || !sixVal || !sevenVal) {
        errorMes.value = "请完善车牌";
      } else if (
        !pattern2.test(threeVal) ||
        !pattern2.test(fourVal) ||
        !pattern2.test(fiveVal) ||
        !pattern2.test(sixVal) ||
        !pattern2.test(sevenVal)
      ) {
        errorMes.value = "不符合规则，请重新输入";
      } else if (eightVal && !pattern2.test(eightVal)) {
        errorMes.value = "不符合规则，请重新输入";
      } else {
        errorMes.value = "";
      }
      emit("change", { value: formData, msg: errorMes.value });
    };

    watch(
      formData,
      () => {
        watchFromData();
      },
      { deep: true }
    );

    watch(
      () => isNev.value,
      async val => {
        formData.eight = "";
        if (val) {
          await nextTick();
          eight.value.focus();
        }
      }
    );

    return {
      formData,
      isNev,
      two,
      three,
      four,
      five,
      six,
      seven,
      eight,
      changeCity,
      changeTwo,
      changeThree,
      changeFour,
      changeFive,
      changeSix,
      handleErr,
      city,
      popupShow,
      errorMes
    };
  }
};
</script>

<style scoped>
.car-number {
  display: grid;
  grid-template-columns: repeat(8, minmax(0, 1fr));
  column-gap: 5px;
}
.error-msg {
  color: #ee0a24;
  font: size 13px;
  margin-top: 6px;
}
.checkbox-view {
  margin-top: 12px;
  display: flex;
}
.nengyuan {
  /* h-[48px] px-[10px] text-[12px] leading-[14px] text-[#959FAC] flex items-center */
  border: 1px solid #ccd3df;
  border-radius: 6px;
  height: 48px;
  background: #fff;
  padding: 0 10px;
  font-size: 12px;
  line-height: 14px;
  color: #959fac;
  display: flex;
  align-items: center;
}

:deep(.van-cell__value) {
  padding-left: 0 !important;
}
:deep(.van-cell) {
  padding: 0 !important;
}
:deep(.van-field__control) {
  text-align: center;
}
</style>
